module.exports = __webpack_public_path__ + "static/media/bg-mobile.3e88525e.png";